import {UserAgentApplication} from 'msal';

export const LOGGED_IN_KEY = 'loggedIn';
const {REACT_APP_DISABLE_AD, REACT_APP_AD_APP, REACT_APP_AD_TENANT} = process.env;
export const checkLogin = () => REACT_APP_DISABLE_AD === 'TRUE' || localStorage.getItem(LOGGED_IN_KEY) === 'true';

const msalConfig = {
  auth: {
    clientId: REACT_APP_AD_APP,
    authority: `https://login.microsoftonline.com/${
      REACT_APP_AD_TENANT
    }`,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: true,
  },
};
const loginRequestOpts = {
  scopes: ['user.read', 'directory.read.all'],
};

// can differ in the future
const tokenRequestOpts = loginRequestOpts;

const msalApp = new UserAgentApplication(msalConfig);

export const logoutUser = () => {
  localStorage.setItem(LOGGED_IN_KEY, false);
  msalApp.logout();
};

const getAccessToken = async () => {
  try {
    const res = await msalApp.acquireTokenSilent(tokenRequestOpts);
    localStorage.setItem(LOGGED_IN_KEY, true);
    return res.accessToken;
  } catch (e) {
    if (e.name === 'InteractionRequiredAuthError') {
      const res = msalApp.acquireTokenPopup(tokenRequestOpts);
      return res.accessToken;
    }
    throw e;
  }
};

export const getTokenOrLogin = async () => {
  if (!msalApp.getAccount()) {
    await msalApp.loginPopup(loginRequestOpts);
  }
  return await getAccessToken();
};
